import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikLED extends ASTBlock {
    constructor(color) {
        super(color, "alvik_led")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "mach die  %1 %2 %3",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "command",
                    "options": [
                        [
                            "OnBoard-LED",
                            "set_builtin_led"
                        ],
                        [
                            "Bodenbeleuchtung",
                            "set_illuminator"
                        ]
                    ]
                },
                {
                    "type": "field_dropdown",
                    "name": "on",
                    "options": [
                        [
                            "an",
                            "True"
                        ],
                        [
                            "aus",
                            "False"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}